export default __webpack_public_path__ + "static/media/handy-qr-logo.4c26cf59.svg";